import { render, staticRenderFns } from "./IndividualRelation.vue?vue&type=template&id=292b6494"
import script from "./IndividualRelation.vue?vue&type=script&lang=ts"
export * from "./IndividualRelation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports